export default __webpack_public_path__ + "static/media/suwas.63a10a55.png";